import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SaudeService from '../../../../../services/saude-auth';



const ProfSaude = () => {
    const [nome, setNome] = useState("");
    const [especialidade, setEspecialidade] = useState("");
    const [foto, setFoto] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const montaForm = async () => {
        const lic = new FormData();
        lic.append("nome", nome)
        lic.append("especialidade", especialidade)
        lic.append('foto', foto);
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        if (foto === "") {
            try {
                const prf = await SaudeService.cadastroProfissionais({
                    nome: nome,
                    especialidade
                })
                if (prf.data["_id"]) {
                    alert("Profissional cadastrado com sucesso!")
                    setSucesso(true);
                }
                else {
                    alert(prf.data["error"]);
                }
            } catch (error) {
                console.log(error)
            }
        }
        else {
            const dados = await montaForm();
            try {
                const lic = await SaudeService.cadastroProfissionais(dados)
                if (lic.data["_id"]) {
                    alert("Profissional cadastrado com sucesso!")
                    setSucesso(true)
                    setError(false)
                } else {
                    alert(lic.data["error"])
                }
            } catch (error) {
                setError(error)
            }
        }
    }

    const handleUploadDocumento = (e) => setFoto(e.target.files[0]);


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setEspecialidade("");
        setFoto("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome do Profissional"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="especialidade">
                                <FloatingLabel
                                    label="Especialidade"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="especialidade"
                                        value={especialidade}
                                        onChange={e => setEspecialidade(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="aviso">
                                <Form.Label>Foto</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="foto"
                                    onChange={handleUploadDocumento}
                                    accept=".jpg, .jpeg, JPG, png"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/saude/profissionais'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Profissional cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/saude/profissionais/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Profissionais
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/saude/profissionais'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default ProfSaude;